export default {
  namespaced: true,
  state: {
    contentCategory: null,
    contentCategoryDescription: null,

  },
  getters: {
    sendingDocument: state => {
      return state.contentCategory === "Document"
    },
    requiresContentCategoryDescription: state => state.contentCategory === "Other"
  },
  actions: {
    resetCurrentDeclaration: (context) => {
      context.commit('resetCurrentDeclaration');
    },
    setContentCategory: (context, contentCategory) => {
      context.commit("setContentCategory", contentCategory);
    },
    setContentCategoryDescription: (context, contentCategoryDescription) => {
      context.commit("setContentCategoryDescription", contentCategoryDescription);
    }
  },
  mutations: {
    resetCurrentDeclaration: (state) => {
      state.contentCategory = '';
      state.contentCategoryDescription = null;
    },
    setContentCategory: (state, contentCategory) => {
      state.contentCategory = contentCategory;
    },
    setContentCategoryDescription: (state, contentCategoryDescription) => {
      state.contentCategoryDescription = contentCategoryDescription;
    }

  }
}
